import { produce } from 'immer';
import { Dispatch, SetStateAction } from 'react';
import Checkbox from '../../../../../common/widgets/Checkbox';
import ErrorViewer from '../../../../../common/widgets/ErrorViewer';
import RadioButton from '../../../../../common/widgets/RadioButton';
import { DependentsCustomType } from '../../../enums';
import { Dictionary } from '../../../models/Categories';
import { ErrorState } from '../../../models/Errors';
import { DependentModel, DependentsConfigModel } from '../../../models/Options';
import { DependentFormItem } from '../types';

interface CustomDependentSelectorProps {
  dependentsConfig: DependentsConfigModel;
  form: Dictionary<any>;
  setForm: Dispatch<SetStateAction<Dictionary<any>>>;
  errors?: ErrorState;
  clearErrors?: (key: string) => void;
}
export default function CustomDependentSelector(
  props: CustomDependentSelectorProps,
) {
  const {
    dependentsConfig: config,
    form,
    setForm,
    errors,
    clearErrors,
  } = props;
  const handleDependentSelected = (item: DependentModel) => {
    clearErrors?.('dependents');
    setForm(
      produce(draft => {
        if (
          props.dependentsConfig?.type === DependentsCustomType.CheckboxList
        ) {
          draft['dependents'].forEach((element: DependentFormItem) => {
            if (item.id === element.dependent.id) {
              element.isSelected = !element.isSelected;
            }
          });
        } else if (
          props.dependentsConfig?.type === DependentsCustomType.RadioButtonList
        ) {
          draft['dependents'].forEach((element: DependentFormItem) => {
            if (item.id === element.dependent.id) {
              element.isSelected = true;
            } else {
              element.isSelected = false;
            }
          });
        }
      }),
    );
  };
  const renderControls = () => {
    if (config.type === DependentsCustomType.CheckboxList) {
      return config.dependents.map((dep: DependentModel) => {
        const selectedItem = form['dependents']?.find(
          (d: DependentFormItem) => d.dependent.id === dep.id,
        );
        const isChecked = selectedItem?.isSelected ?? false;

        return (
          <div key={dep.id} className="flex items-center mb-2">
            <Checkbox
              id={`dep-${dep.id}`}
              label={dep.legalName}
              isChecked={isChecked}
              onChange={() => handleDependentSelected(dep)}
            />
          </div>
        );
      });
    } else if (config.type === DependentsCustomType.RadioButtonList) {
      return config.dependents.map((dep: DependentModel) => {
        const selectedItem = form['dependents']?.find(
          (d: DependentFormItem) => d.dependent.id === dep.id,
        );
        const isChecked = selectedItem?.isSelected ?? false;

        return (
          <div
            key={dep.id}
            className="product-options products-options-checkbox"
          >
            <RadioButton
              id={`dep-${dep.id}`}
              name="dependents"
              label={dep.legalName}
              value={dep.id}
              checked={isChecked}
              onChange={() => handleDependentSelected(dep)}
            />
          </div>
        );
      });
    }
    return null;
  };

  return (
    <div>
      {renderControls()}
      <ErrorViewer errors={errors?.['dependents']} />
    </div>
  );
}
